import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const legalEntitiesService = new CachedService(entities.Orderadmin_Accounts_Entity_LegalEntity, '/accounts/legal-entity', HALApiService, createItemsData)
